import { useCallback, useEffect } from "react";

export const useUndoRedoShortcuts = (
  onUndo: () => void,
  onRedo: () => void,
  canUndo: boolean,
  canRedo: boolean
) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement ||
        (event.target instanceof HTMLElement && event.target.isContentEditable)
      )
        return;

      const isModifier = event.metaKey || event.ctrlKey;
      if (!isModifier) return;

      // Cmd/Ctrl+Shift+Z or Cmd/Ctrl+Y → Redo
      if (
        (event.key === "z" && event.shiftKey) ||
        (event.key === "y" && !event.shiftKey)
      ) {
        if (canRedo) {
          event.preventDefault();
          onRedo();
        }
        return;
      }

      // Cmd/Ctrl+Z → Undo
      if (event.key === "z" && !event.shiftKey) {
        if (canUndo) {
          event.preventDefault();
          onUndo();
        }
      }
    },
    [onUndo, onRedo, canUndo, canRedo]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);
};
